module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/7K8BNx0YONlVaGZ7gs2Ajz-1f48964ac1e7424dc7bb99c9850a6f17.jpg";